export const fetchSignedUrl = async (key) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_NAADAN_API}signedUrl?fileKey=${key}`
    );
    const data = await response.json();
    console.log(data);
    if (data?.url) {
      return data.url; // return the signed URL
    } else {
      console.error("Failed to get signed URL");
      return null;
    }
  } catch (error) {
    console.error("Error fetching signed URL:", error);
    return null;
  }
};
